












































































































import { Component, Watch } from 'vue-property-decorator';
import { CardForm } from '@/components/bwaff';
import FormMixin, { Send } from '@/components/form-base';
import api, { Api }  from '@/services';
import { mixins } from 'vue-class-component';

import RegisterStep from '@/views/pages/components/register-step.vue';
import VueRecaptcha from 'vue-recaptcha';
import Recaptcha from '@/views/pages/mixins/recaptcha-mixin.vue';
import Vue from 'vue';

@Component({
  components: {
    CardForm,
    RegisterStep,
    VueRecaptcha
  }
})
export default class RegisterForm1 extends mixins(FormMixin, Recaptcha) {
  edit: boolean = true;
  show_password: boolean = false;
  email: string = '';
  password: string = '';
  firstName: string = '';
  lastName: string = '';
  promoCode: string = '';
  loading: boolean = false;
  api: Api = api;

  firstNameValidation(){
    if(!this.firstName){
      Vue.set(this.state, 'firstName:error', this.t('{0} is required',[this.t('First name')]));
      return false
    }
    if(this.firstName.length>75 || this.firstName.length<2){
      Vue.set(this.state, 'firstName:error', this.t('Should be at least 2 and less than 75 letters'));
      return false
   }
   return true
  }

  lastNameValidation(){
    if(!this.lastName){
      Vue.set(this.state, 'lastName:error', this.t('{0} is required',[this.t('Last name')]));
      return false
    }
    if(this.lastName.length>75 || this.lastName.length<2){
      Vue.set(this.state, 'lastName:error', this.t('Should be at least 2 and less than 75 letters'));
      return false
   }
   return true
  }

  passwordValidation(){
    if(!this.password){
      Vue.set(this.state, 'password:error', this.t('{0} is required',[this.t('Password')]));
      return false
    }
    if(this.password.length<8){
      Vue.set(this.state, 'password:error',this.t('Field "{0}" must contain at least 8 chars',[ this.t('Password')]));
      return false
   }
   return true
  }

  emailValidation (){
    if(!this.email){
      Vue.set(this.state, 'email:error', this.t('{0} is required',[this.t('Email')]));
      return false
    }

    this.api.validate('user', 'email-free', this.email)
      .then((result) => {
        if(!result.isValid){
          Vue.set(this.state, 'email:error', this.t('Account with this email already registered'));
        }
      });
    
    this.api.validate('user', 'email-valid', this.email)
      .then((result) => {
        if(!result.isValid){
          Vue.set(this.state, 'email:error', this.t('Field "{0}" should be a valid email address', [ this.t('Email') ]));
        }
      });
   return true
  }

  mounted() {
    this.promoCode = this.promo;
  }

  get promo() {
    return this.$route.query.promo as string;
  }

  get trackingId() {
    return this.$route.query.trackingId as string;
  }

  get disabledBtn(){
    return !this.firstName ||
    !this.lastName ||
    !this.email ||
    !this.password ||
    this.hasErrors || !this.recaptchaResponse;
  }

  @Send()
  submit() {
    const referredBy = this.$cookies.get('referralId');
    this.loading = true;

    return this.api.register({
      email: this.email,
      password: this.password,
      firstName: this.firstName,
      lastName: this.lastName,
      promoCode: this.promoCode,
      recaptchaResponse: this.recaptchaResponse,
      trackingId: this.trackingId ? this.trackingId : '',
      referredBy: referredBy || '',
      language: this.$i18n.locale
    }).then(() => {
      this.api.login(
        {
          email: this.email,
          password: this.password,
          rememberMe: true
        }, 
        {
          showLoader: false
        }
      )
      .catch((err) => {
        this.$router.push('/login');
      })
      .finally(() => {
        this.loading = false;
         this.$store.commit('loading', false);
      })
    })
    .catch((err) => {
      (this.$refs.recaptcha  as any).reset();
      this.recaptchaResponse = '';

      this.loading = false;

      return Promise.reject(err);
    });
  }
}
